/**
 * @generated SignedSource<<f5c060c7c576e260a291bd24dbf252d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SplitNoteInput = {
  clientMutationId?: string | null;
  id: string;
  useForNewNotes: boolean;
};
export type NoteCardSplitMutation$variables = {
  input: SplitNoteInput;
};
export type NoteCardSplitMutation$data = {
  readonly splitNote: {
    readonly clientMutationId: string | null;
    readonly note: {
      readonly id: string;
      readonly stream: {
        readonly " $fragmentSpreads": FragmentRefs<"stream_mainstream">;
      };
    };
    readonly ok: boolean;
  } | null;
};
export type NoteCardSplitMutation = {
  response: NoteCardSplitMutation$data;
  variables: NoteCardSplitMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenByUser",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTopUser",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v22 = [
  (v4/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v25 = [
  {
    "kind": "Literal",
    "name": "onlyMeetingFeedback",
    "value": false
  }
],
v26 = [
  (v4/*: any*/),
  (v10/*: any*/),
  (v20/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoteCardSplitMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SplitNotePayload",
        "kind": "LinkedField",
        "name": "splitNote",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "stream_mainstream"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoteCardSplitMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SplitNotePayload",
        "kind": "LinkedField",
        "name": "splitNote",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "watching",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanDelete",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HomePanelGroup",
                    "kind": "LinkedField",
                    "name": "homePanelGroup",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emojiName",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "otherUser",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "relationshipToViewer",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v6/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInternalAttributes",
                        "kind": "LinkedField",
                        "name": "internalAttributes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NonNullFeedbackConnection",
                            "kind": "LinkedField",
                            "name": "oneononeFeedbackList",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NonNullFeedbackEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FeedbackNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "filters": null,
                            "handle": "connection",
                            "key": "stream_oneononeFeedbackList",
                            "kind": "LinkedHandle",
                            "name": "oneononeFeedbackList"
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStreamUser",
                    "kind": "LinkedField",
                    "name": "notestreamusers",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accessType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          (v19/*: any*/),
                          (v11/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          (v20/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isConfigured",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isGuest",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasReceivedInvites",
                            "storageKey": null
                          },
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "account",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v4/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v8/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": "image",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "logo",
                        "storageKey": null
                      },
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Note",
                    "kind": "LinkedField",
                    "name": "latestNote",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "event",
                        "plural": false,
                        "selections": (v22/*: any*/),
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkedEventGuid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "linkedEvent",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "nextOccurrence",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "start",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "end",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "finalOccurrence",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "guid",
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recurrenceRule",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStreamPublicLink",
                    "kind": "LinkedField",
                    "name": "publicLink",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enabled",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStreamInvite",
                    "kind": "LinkedField",
                    "name": "pendingStreamInvites",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dismissedExpiryPopup",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "archived",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "openActionItemCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "groupName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "claimedEvents",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Attendee",
                        "kind": "LinkedField",
                        "name": "attendees",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "noteWithRecordingExists",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "askCopilotConversationExists",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v25/*: any*/),
                    "concreteType": "NonNullFeedbackConnection",
                    "kind": "LinkedField",
                    "name": "feedbackList",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NonNullFeedbackEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FeedbackNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v4/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": "feedbackList(onlyMeetingFeedback:false)"
                  },
                  {
                    "alias": null,
                    "args": (v25/*: any*/),
                    "filters": [
                      "onlyMeetingFeedback"
                    ],
                    "handle": "connection",
                    "key": "stream_tabs_feedbackList",
                    "kind": "LinkedHandle",
                    "name": "feedbackList"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStreamTabNode",
                    "kind": "LinkedField",
                    "name": "tabs",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "otherStreamId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "order",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isEmbedded",
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStream",
                    "kind": "LinkedField",
                    "name": "relatedStreams",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "account",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v8/*: any*/),
                          (v4/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isShared",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasAnyAutomationActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "schedulingMeetingAssistantAutomationIsActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "meetingRecapAutoShareSource",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": "sendTo_S",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sendTo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "setBy",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "StreamMeetingRecapAutoShareSettings",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": "sendTo_U",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sendTo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "UserMeetingRecapAutoShareSettings",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v22/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMeetingFeedbackTabEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "objectivesTabEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "objectivesFilterAssignee",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "objectivesFilterStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "objectivesFilterCycle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v15/*: any*/)
                    ],
                    "type": "HomePanelObjectInterface",
                    "abstractKey": "__isHomePanelObjectInterface"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "722c9892f8ad182be77cacbb04872e9a",
    "id": null,
    "metadata": {},
    "name": "NoteCardSplitMutation",
    "operationKind": "mutation",
    "text": "mutation NoteCardSplitMutation(\n  $input: SplitNoteInput!\n) {\n  splitNote(input: $input) {\n    clientMutationId\n    ok\n    note {\n      id\n      stream {\n        ...stream_mainstream\n        id\n      }\n    }\n  }\n}\n\nfragment ExportToDocs_stream on NoteStream {\n  id\n  displayName\n}\n\nfragment HomePanelGroupMenuButton_stream on NoteStream {\n  id\n  type\n  archived\n  homePanelGroup {\n    name\n    emojiName\n    type\n    id\n  }\n  ...HomePanelGroupsMenu_object\n}\n\nfragment HomePanelGroupsMenu_object on HomePanelObjectInterface {\n  __isHomePanelObjectInterface: __typename\n  id\n  __typename\n  ... on NoteStream {\n    type\n  }\n  homePanelGroup {\n    id\n    name\n  }\n}\n\nfragment LinkEventButton_stream on NoteStream {\n  ...LinkEventModal_stream\n  ...useEventState_stream\n  id\n  dismissedExpiryPopup\n  linkedEvent {\n    title\n    recurrenceRule\n    nextOccurrence {\n      start\n      id\n    }\n    id\n  }\n  otherUser {\n    id\n    type\n    image\n    fullName\n  }\n}\n\nfragment LinkEventModal_stream on NoteStream {\n  ...useEventState_stream\n  id\n  otherUser {\n    id\n    fullName\n  }\n  linkedEvent {\n    id\n    guid\n    title\n    recurrenceRule\n    nextOccurrence {\n      start\n      end\n      id\n    }\n    finalOccurrence\n  }\n}\n\nfragment MeetingTitleAndXWCSwitcherOption_stream on NoteStream {\n  id\n  displayName\n  url\n  account {\n    __typename\n    id\n    logo\n    name\n  }\n}\n\nfragment MeetingTitleAndXWCSwitcher_ExternalStreamTooltip_stream on NoteStream {\n  id\n  isExternal\n  account {\n    __typename\n    name\n    id\n  }\n  relatedStreams {\n    id\n    isExternal\n    account {\n      __typename\n      name\n      id\n    }\n  }\n}\n\nfragment MeetingTitleAndXWCSwitcher_stream on NoteStream {\n  isExternal\n  account {\n    __typename\n    id\n    image: logo\n    name\n  }\n  ...MeetingTitleAndXWCSwitcher_ExternalStreamTooltip_stream\n  ...MeetingTitleAndXWCSwitcherOption_stream\n  relatedStreams {\n    id\n    isExternal\n    account {\n      __typename\n      id\n      name\n    }\n    ...MeetingTitleAndXWCSwitcherOption_stream\n  }\n}\n\nfragment MoreActionsMenu_stream on NoteStream {\n  id\n  displayName\n  type\n  watching\n  viewerCanDelete\n  isExternal\n  homePanelGroup {\n    id\n  }\n  otherUser {\n    id\n  }\n  notestreamusers {\n    id\n    accessType\n    user {\n      id\n    }\n  }\n  account {\n    __typename\n    name\n    id\n  }\n  ...useAskForFeedback_stream\n  ...LinkEventModal_stream\n  ...ShareButton_stream\n  ...ExportToDocs_stream\n}\n\nfragment ShareButton_stream on NoteStream {\n  id\n  url\n  isExternal\n  publicLink {\n    enabled\n    id\n  }\n  notestreamusers {\n    accessType\n    user {\n      id\n      isExternal\n    }\n    id\n  }\n  pendingStreamInvites {\n    id\n    email\n  }\n}\n\nfragment SideBar_allowedTabs_stream on NoteStream {\n  isExternal\n  notestreamusers {\n    user {\n      email\n      id\n    }\n    id\n  }\n  claimedEvents {\n    attendees {\n      email\n    }\n    id\n  }\n  noteWithRecordingExists\n  askCopilotConversationExists\n}\n\nfragment StreamHeader_stream on NoteStream {\n  ...MoreActionsMenu_stream\n  ...LinkEventButton_stream\n  ...HomePanelGroupMenuButton_stream\n  ...ShareButton_stream\n  ...TabsAndBookmarks_stream\n  ...MeetingTitleAndXWCSwitcher_stream\n  id\n  displayName\n  groupName\n  type\n  isExternal\n  isShared\n  hasAnyAutomationActive\n  schedulingMeetingAssistantAutomationIsActive\n  meetingRecapAutoShareSource {\n    __typename\n    ... on StreamMeetingRecapAutoShareSettings {\n      id\n      sendTo_S: sendTo\n      setBy {\n        id\n        fullName\n        firstName\n      }\n    }\n    ... on UserMeetingRecapAutoShareSettings {\n      id\n      sendTo_U: sendTo\n      user {\n        id\n        fullName\n        firstName\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  account {\n    __typename\n    name\n    id\n  }\n  otherUser {\n    id\n    fullName\n    image\n    isTopUser\n  }\n}\n\nfragment TabsAndBookmarksTab_stream on NoteStream {\n  tabs {\n    id\n    title\n    icon\n    url\n    otherStreamId\n    order\n  }\n}\n\nfragment TabsAndBookmarks_stream on NoteStream {\n  id\n  displayName\n  type\n  openActionItemCount\n  groupName\n  isExternal\n  ...SideBar_allowedTabs_stream\n  otherUser {\n    relationshipToViewer\n    internalAttributes {\n      oneononeFeedbackList {\n        edges {\n          node {\n            id\n            isArchived\n            lastSeenByUser\n            updatedAt\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      id\n    }\n    id\n  }\n  feedbackList(onlyMeetingFeedback: false) {\n    edges {\n      node {\n        isArchived\n        lastSeenByUser\n        updatedAt\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  tabs {\n    id\n    otherStreamId\n    icon\n    title\n    order\n    isEmbedded\n    url\n  }\n}\n\nfragment context_StreamUsersTypeContext_streamUsers on NoteStream {\n  notestreamusers {\n    id\n    accessType\n    user {\n      id\n      email\n      image\n      fullName\n      lastName\n      firstName\n      isActive\n      isConfigured\n      isGuest\n      hasReceivedInvites\n      isTopUser\n      isExternal\n      account {\n        __typename\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment stream_mainstream on NoteStream {\n  ...StreamHeader_stream\n  ...TabsAndBookmarksTab_stream\n  ...context_StreamUsersTypeContext_streamUsers\n  id\n  type\n  displayName\n  isMeetingFeedbackTabEnabled\n  objectivesTabEnabled\n  objectivesFilterAssignee\n  objectivesFilterStatus\n  objectivesFilterCycle\n  otherUser {\n    id\n    type\n    fullName\n    isActive\n    relationshipToViewer\n  }\n  owner {\n    id\n  }\n  notestreamusers {\n    id\n    accessType\n    user {\n      id\n      email\n      image\n      fullName\n      lastName\n      firstName\n      isActive\n      isConfigured\n      isGuest\n      hasReceivedInvites\n      isTopUser\n      isExternal\n      account {\n        __typename\n        id\n        name\n      }\n    }\n  }\n  latestNote {\n    event {\n      id\n    }\n    id\n  }\n}\n\nfragment useAskForFeedback_stream on NoteStream {\n  type\n  latestNote {\n    event {\n      id\n    }\n    id\n  }\n  otherUser {\n    id\n    isActive\n    relationshipToViewer\n  }\n}\n\nfragment useEventState_stream on NoteStream {\n  linkedEventGuid\n  linkedEvent {\n    nextOccurrence {\n      start\n      end\n      id\n    }\n    finalOccurrence\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "40586f48778f8156863e70e4c8170dcc";

export default node;
